import { Component, OnInit } from '@angular/core';
import { VidSluchajService } from '../../services/vid-sluchaj.service';
import { VidSluchaj } from '../../beans/vid-sluchaj';

@Component({
	selector: 'app-vid-sluchaj-admin',
	templateUrl: './vid-sluchaj-admin.component.html',
	styleUrls: ['./vid-sluchaj-admin.component.scss']
})
export class VidSluchajAdminComponent implements OnInit {

	rows: VidSluchaj[] = [];
	recomputing = false;

	constructor(private service: VidSluchajService) { }

	ngOnInit() {
		this.load();
	}

	load() {
		this.service.getAll().subscribe(r => this.rows = r);
	}

	addNew() {
		this.rows.unshift({
			name: '',
			broiSeVDela: false,
			broiSeVPretentsii: false
		});
	}

	save(v: VidSluchaj) {
		this.service.save(v).subscribe(saved => Object.assign(v, saved));
	}

	delete(v: VidSluchaj) {
		if (!v.id) {
			// Нов нерезирван ред — просто го махаме от списъка
			this.rows = this.rows.filter(r => r !== v);
			return;
		}
		if (!confirm(`Изтриване на '${v.name}'?`)) {
			return;
		}
		this.service.delete(v.id).subscribe(
			() => {
				this.rows = this.rows.filter(r => r.id !== v.id);
			},
			err => {
				// 409 → има дела с този вид; backend връща приятелски message
				const msg = (err && err.error && err.error.message)
					|| 'Грешка при изтриване';
				alert(msg);
			}
		);
	}

	refresh() {
		this.load();
	}

	/**
	 * Преизчислява вида случай за делата с 'Незнаен'/'Трудова злополука' по
	 * текущите флагове на лицата. Пуска се след ръчна корекция на флаговете
	 * is_insurer / obshtina — не пипа ръчно зададени видове.
	 */
	recompute() {
		const msg = 'Преизчисляване на „Вид случай“ за делата с „Незнаен“ и „Трудова злополука“ '
			+ 'по текущите ответници (застраховател / община / ЮЛ).\n\n'
			+ 'Ръчно зададените ПТП / Каско / Паднал-Община / Щети НЯМА да бъдат пипани.\n\n'
			+ 'Препоръка: пуснете това СЛЕД като сте коригирали флаговете застраховател/община по лицата.\n\nПродължавате?';
		if (!confirm(msg)) {
			return;
		}
		this.recomputing = true;
		this.service.recompute().subscribe(
			res => {
				this.recomputing = false;
				alert('Готово. Преизчислени дела: ' + (res && res.changed != null ? res.changed : 0));
				this.load();
			},
			err => {
				this.recomputing = false;
				const m = (err && err.error && err.error.message) ? ': ' + err.error.message : '';
				alert('Грешка при преизчисляване' + m);
			}
		);
	}
}
